var api = require("!../../../../../demo/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../../demo/node_modules/css-loader/dist/cjs.js!../../../../../demo/node_modules/less-loader/dist/cjs.js??clonedRuleSet-3[0].rules[0].use[2]!./drop-down-editor.less");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};